import React from 'react';
import { Box, TextField } from '@mui/material';
import { AudioBlockData } from '../../../../models/courses';

interface AudioBlockProps {
  data: AudioBlockData;
  onChange: (_data: AudioBlockData) => void;
  disabled?: boolean;
}

export const AudioBlock: React.FC<AudioBlockProps> = ({
  data,
  onChange,
  disabled,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <TextField
        label="URL аудиофайла"
        size="small"
        fullWidth
        value={data.src}
        onChange={(e) => onChange({ ...data, src: e.target.value })}
        disabled={disabled}
        placeholder="/assets/audio.mp3"
      />
      <TextField
        label="Подпись"
        size="small"
        fullWidth
        value={data.caption}
        onChange={(e) => onChange({ ...data, caption: e.target.value })}
        disabled={disabled}
      />
    </Box>
  );
};
